import axios from "axios";
import React, { useEffect, useState } from "react";
import ProductBox from "../product-box/product-box.component";
import "./mini-shop-directory.styles.css";

const MiniShopDirectory = ({ selectedCategory }) => {
  const [productsData, setProductsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        let allProducts = [];
        let nextPageUrl =
          "https://mediumaquamarine-rat-574365.hostingersite.com/api/products";

        while (nextPageUrl) {
          const formData = new FormData();
          formData.append("campaign_id", "2");

          const response = await axios.post(nextPageUrl, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (response.data.is_status) {
            const { products, link } = response.data.data;
            allProducts = [...allProducts, ...products];
            nextPageUrl = link.next ? link.next : null;
          } else {
            nextPageUrl = null;
          }
        }

        setProductsData(allProducts);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllData();
  }, []);

  // Filter products based on selected category
  const filteredProducts =
    selectedCategory === "محصولات"
      ? productsData
      : productsData.filter((product) => product.category === selectedCategory);

  if (isLoading) {
    return (
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="mini-shop-directory">
      {filteredProducts.map((product) => (
        <ProductBox key={product.id} cat={product} />
      ))}
    </div>
  );
};

export default MiniShopDirectory;
